// TODO: do not check by value
import { Scenarios } from './types';

export const MATERIAL_NOT_APPLICABLE_VALUE = 'Sans objet';

export const SCENARIO_NUMBER_MAP: Record<Scenarios, number> = {
    [Scenarios.essentialWorks]: 1,
    [Scenarios.workToBeConsidered]: 2,
};
